export default {
    Detail: 1,
    Notes: 2,
    Profile: 3
}